import React from 'react';
import TitleText from '../atomic_components/TitleText';
import './WonderBrink.css';

const WonderBrink: React.FC = () => {
  return (
    <div className="creative-morning-container">
      <div className="creative-morning-hero">
        <TitleText text="WonderBrink @ Buffalo" size="large" className="cm-title" />
        <p className="cm-subtitle">

        My close mentor homeschooled her kids to protect their ability to think. She focused so much time on making sure her kids understood how to see the world practically. One that sets goals that start with planning the resources the local community has access to. A much better strategy for working-class people. She believed school was not providing those skills for working-class people.
          <br></br>

          <br></br>
          This September, I was invited to teach a new technology course that would be "radical". One that seeks to fight to utilize the 3d printers that are left idle in our school. This is the perfect time, I said, it's a great chance to bring a course that can connect to the community, and the resources that are available to us. One that parents can say is just as high-quality as by the kids' own "entrepreneurship", "job learning", or college, but with the added benefit of being able to engage in relationships with the community, which only get better with more people and time.
          <br></br>
          <br></br>
          I soon learned that replacing all these systems comes with replacing many moving parts that make up education. Still, I'm not sure about all the details, especially trying not to drop the ball on student rigor and student discipline.
          <br></br>
          <br></br>

          Still, it's going to be awesome, a course that is connected to years of scholastic research, with wide-reaching social benefits. Starting with including skills of our border community, children's autonomy, and critical learning.
        </p>
      </div>

      <section className="cm-content-section">
        <div className="cm-concept-card">
          <h3>
          Trying to make room for all resources in the classroom in working-class communities. Making more with what is already here.
          </h3>
          <p>
          When parents show up to parent-teach conferences, they are implicitly asked to contribute to the teacher's authority. Students are asked to accept minimal ideas of success framed as objective knowledge. Teachers, on their own, are subject to a huge confirmation bias that the only way to be successful is to send students to be like our individualistic elites, instead of retaining a strong visual of how students' parents and grandparents were able to be successful in their own communities. (Culturally Sustained Teaching) 
          </p><p>
          At the same time, parents deserve to know that their kids are trained adequately, where students are given space
We need to recognize that making every student compete only on what is commonly considered elite levels of success, while it's not common in a community, is not an effective way to create the most value from all resources. Students can get value from all resources. They are not distractions. All things that students are motivated by help teach reading, science, math, and technology. All things that can keep kids interested are a major part of what our education needs.
I am not the only one noticing this. But I hope to use new tools to bring this to light. Technology can and should be used to invite and create a magnet for the community at the school. All those with an interesting story are what students need. I created a single point of contact for all parents, teachers, community members, and students to be able to communicate with me. Along with their student comes a flier with a list of questions based on the class curriculum. This is where the parent can help me cater this class, to better suit this community. To be something that each student knows how to explain to their parents.
          </p>
         <p>
          I am not the only one noticing this. but I hope too use new tools to bring this to light. 

          Technology can annd should be used to invite and create a magnet for the community at the school. 
          All those with a interesting story, is what students need.

          I created a single point of contact for all parents, teachers, community members, and students to be able to communicate with me.
          Along with their student, comes a flier with a list of questions based on the class curriculum. This is where the parent can help me cater this class, to better suit this community. To be something that each student knows how to explain to their parents.
         </p>

        </div>

        <div className="cm-concept-card">
          <h3> Why do we think that kids starting businesses and other community work outside of school are capable of way more success?
 
            
            <br />
            What does that mean for the incentives of our education?
            <br />
            Are we making education way less complex than what the real world is really like?          </h3>
          <p>
          How often do we want to have teachers who can highlight the risks, collaboration, and benefits that we see about this technique in the real world? Is a lack of relevant critical, historical, and current moment a real problem for working-class students?
          </p>
          <p>

          The world is a complex place, but setting up choices can help students grapple with that complexity in a strong way. Take a page from the trades, the makerspaces. These teachers don't tell you what the right decision is. They lay out to you the tools and materials of the job.

          </p>
          <p>They show that you can get it wrong. They ask, which of these should you use? And move from there. This is the same as a classroom. Show the students the complexity, along with the action needed to overcome it.</p>
          <p>


          Parents should know that their children are getting taught the basics, and know where the basics are used outside the classroom.

          </p>
        </div>

        <div className="cm-concept-card">
          <h3>Discipline and failing.</h3>
          <p>
          I understand why failing is a last resort. Many students try when backed against a wall. At that moment of being backed up against a wall, that's where you may find the sign of consequence vs reward. Create ways for students to understand a simple concept and show it back to you. For underperforming classes, you can't just lecture. You gotta offer short-term rewards, novelty, and day by day without for disruptive behavior. You can explain early in the class, as classroom management improves, those techniques become archaic, and teaching towards independence is necessary and possible. Students need to find empathy for each other. It's a baseline requirement that needs to be experienced, with appropriate, clear, and reformative punishments. I am inspired by voices in the cafeteria. It's there. I have great honor and respect for Ms Cannon, and her strong will to enforce a cafeteria that is tasked with ensuring that students have the chance to correct and understand mistakes. Those who make a mess on the floor are the ones who can be tasked with cleaning it. Giving value to the work of others and the space where they go to school. 



          </p>
        </div>

        <div className="cm-concept-card">
          <h3>Intelligencial Disability
          </h3>
          <p>
          From the books of Triano, Sleeters. Intellectual Disability is not something that should be given out without specific neurological conditions being found. Students can be adapted to, and New York City is intentionally about specific and careful individual plans that are created to maximize their success. Good news, we need not create a blanket separation for students who have these unique traits.


          </p>
        </div>
        <div className="cm-concept-card">
          <h3>Stewardship</h3>
          <p>
          Parents want schools to care for students and communities, not just produce workers. Stewardship means teaching ethics alongside skills like 3D printing or basic electronics. Our students in NYC are full of people who face a world they find is unkind to them in the past, and yet is dedicated to making students feel safe in the present. Students need to give in to the softening pressure. Take a page from Eve and Yang with Decolonization is not a metaphor. Students should be introduced to a clear-minded discussion between long-lasting community damage and the continuation of "guilt reliving" that seeks to appease, but not materially give power to those experiencing generational harm. Students must learn to sit in the shoes of collective action. To be able to understand what winning looks like and how it's possible.
          </p>
          
          </div>
          <div className="cm-concept-card">
            <h3> Not Extraction</h3>
          <p>
          I want to be very clear on how to steward the technology that these students are learning. Drones and the learning that all our classes are understanding how to build, is connected to the intense and invisible surveillance that is at the core of our society, and is extremely distasteful.
          </p>
          <p>
            
From ice to the FBI to policing to the silencing of opinions, there is a significant risk.
          </p>

          <p>
Students need to put themselves in the shoes of technological workings. Yes, but a tool, without a mind is a force hammer looking for a nail. We need students to find the hope and inspiration in their life. We need them to find what they want to multiply.
          </p>
          <p>
            
Its time now to lean on organizations that are already fighting. Like tech workers. DSA tech action. Personal Networks. Tech unions. University. Students. The power of humanity in technology is a requirement for students. Without the nuance, students are ripe for exploitation, and that's exactly what they are already curious about.


          </p>
        </div>

        <div className="cm-concept-card">
          <h3>Creating independant learners</h3>
          <p>
          Students are told what to do every second of the day. If they are in my class, that means they actually have 0 responsibilities that are outside of direct orders, through extensive oversight and teacher adjustment.
          Parents and teachers are afraid of how little students learn after a class is over.
          </p>
          <p>

          Parents and teachers are afraid of how little students learn after a class is over. Students are hungry to be given purpose. Sandy Grande's Red Pedagogy was the focus and the technique of direct instruction. Where students are given a model, and are asked to grapple with being an advocate for a NYCHA resident. Teachers can cover for students who want to work on the fun, complete things, without sacrificing hours of classroom time, through scaffolding for those who need it, to bring up the baseline of what students are performing. While allowing freedom for kids who are ready to be without. Training wheels for the mind. Students are told, when you do it on your own, make sure to have this, that, and this. When you have time, try working on this on a bigger project or with a more interesting project.

            
          </p>
        </div>
      </section>

      <section className="cm-opportunity-section">


        <div className="cm-opportunity-card">
          <h3>Center Family Knowledge</h3>
          <p>
          I want to center family knowledge, and how to best use the resources that are available to us. Mini project gives many opportunities to bring in relevant and specific highlight that matches the community.
          </p>
          <p>
Make mini projects on practical scenarios part of the curriculum. Let parents suggest projects and topics that matter to their children.
          </p>

          <p>
The first time I ran a trial like this, I asked my students to create a presentation that centered on NYCHA voices in a piece that explained how to fix the physical needs assessment that has no idea how to fix.
          </p>
          <p>
          I was shocked at how stuck they were in coming up with how to form an argument with PowerPoint slides. It's so important to provide more support in places where the classroom becomes more complex with the introduction of real-life situations.

          </p>
        </div>


        <div className="cm-opportunity-card">
          <h3>Community-Driven Projects 
            <br />
            Students deserve to do work that is interesting, good and positive for thier community. 
          </h3>
          <p>

          There is no question. Without the work being done in school, finding a place outside of school is difficult. Students can quickly tell that it's busy work, testing them on only reiterating back good behavior. Some students can exist as the morality rule follower. Yet we know it's not for everyone. Let them be visionary/social change maker, careful therapists, we need the role of all these people as the priority for these kids. How can they show up better today than yesterday?
          </p>
          <p>
Great connection, as a wide array of practice is already super relevant for what they need to be working on.
          </p>
          <p>
How are we going to come up with really valuable side projects with members of the community to make an easy connection?
          </p>
          <p>
          Here are the projects that are listed now:

            <ol>
              <li>Student grade transfer keyboard shortcuts: Programs to transfer student grades from Google Classroom to Jupiter.
              </li>

              <li>Teacher timer device
              Create a vibration-silent timer for more classroom independent work by the teacher.
              </li>
              <li>Teacher class management buttons
              Teacher class management buttons: Create easy buttons at the teacher's desk for repetitive classroom management tasks.
              </li>
              <li>Class Schedule & Student Hallway Signout Device
              Create class schedule api, create hallway signout api, create a touch screen small screen with Pi Nano, create a 3d printed shell.
              </li>
            </ol>
          </p>
        </div>

        <div className="cm-opportunity-card">
          <h3>Focus on Hopeful and Average perceptions of this topic</h3>
          <p>
          A huge part of the idea was how to bring in more people from the industry. How can I make this class extremely relevant to real-life discussions, with real connections that can bring resources to my students?
          </p>
          <p>
            
I was able to start with 3 people that I had direct access to, and one who could provide trust for the next series of speakers. With these speakers, they can help teach, but sneak in, really deep industry thinking, stories, and scenarios.
          </p>
          <p>
            
Through this action, John Dewey's Pedagogy Creed can help students visualize what education can look like.
          </p>
          <p>
          
From ice to the FBI to policing to the silencing of opinions, there is a significant risk.
          </p>
          <p>
            
With Mr. Colin, Mr. Miller, and many other teachers, I can reassure them that they can rely on my students to use the 3d printers, if my students can learn enough.
          </p>
          <p>
            
There is a huge incentive to provide this community resource now. It's not just support, but it's attention and trust.

          </p>
        </div>

        <div className="cm-opportunity-card">
          <h3>Build Critical Awareness</h3>
          <p>
          Teach students to spot bias about technology, ask who benefits from a technology, and choose ethical responses. Critical thinking becomes a practical skill.
          </p>
          <p>
            
Strong literacy, of incentives and how to best create a mental model of a problem and the correct answer, is the biggest problem that needs to be addressed.
          </p>

          <p>
            
Students could be fighting for greater ability to be an active listener in conversations, in all media. Including the one blasting at them in their pockets. They have the skills after years of digital access, they just don't practice bringing it to attention and giving it space in their conscious mind.
            <br />
            
             <a href="https://lth.engineering.asu.edu/reference-guide/blooms-taxonomy/" target="_blank" rel="noopener noreferrer">Learn more about Bloom's Taxonomy</a> 
          </p>
        </div>
      </section>

      <section className="cm-cta-section">
        <h2>Why This Matters</h2>
        <p className="cm-cta-text">
        Parents rightfully hesitate about the quality of American education, where schools can ignore essential starting points, the model from families' voices, and the resources that are available to children, that could be used to help them achieve incredible things today. Students are rightfully discontent with how they are less and less appreciated in a world where grifting and systemic extraction are rampant, with few hopeful figures who want to stand up for them.


        </p>



        <p className="cm-cta-text">
         
        Kids don't see the chance to be excited by a wide selection of useful new ideas, where they can be up to date with people from around the world. It's for this reason that I designed this helpful tool for teachers to quickly build a newsletter that highlights and invites feedback, retractions, and continuous communication with participants. Truthfully, most teachers would love to have thoughtful parents helping them achieve incredible things, hand in hand. I am also looking for more volunteers to contribute to my DRONE class, where I apply many of these concepts to the students in the class. Sign up here:

          Sign up here: 
          <br />
          <a href="https://docs.google.com/forms/d/e/1FAIpQLScHAqOUrXMNpiaF9KRVLfB_mRun0A0b7bScHF7kulNNdzR4bg/viewform?usp=publish-editor"> 
          Sign Up link
          
          </a>
        </p>
      </section>

      <section className="cm-opportunity-card">
          <h3>Thanks</h3>
                <p>
        and to my social foundations teacher. I appreciate your allowance to have me submit this as my final project. 
        
        Begeing able to find connection between our social foundations class and all the below.

        <ol>
          <li>My talk in Buffalo</li>
          <li>Preparing for an upcoming class that I hope to begin teaching in Spring 2026</li>
          <li>My substitute teaching</li>
          <li>College Now teaching</li>
        </ol>
        
        Is exactly how teachers like me can have the space to test ideas and see what works.


        </p>

        <h3>Highlighted media</h3>



      <div style={{ marginTop: '2rem', textAlign: 'center' }}>
        <iframe
          width="315"
          height="560"
          src="https://www.youtube.com/embed/W4Z5mAknet8"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>
      </section>
    </div>
  );
};

export default WonderBrink;
